import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
    LinearProgress,
    SelectChangeEvent,
    Theme,
    Typography
} from "@mui/material";
import {
    Form,
    Formik,
    FormikProps
} from "formik";
import * as Yup from 'yup';
import { MandateCreation, MandateListItem, MandatesListResBody } from "../../redux-store/types/investorProfile";
import MFSelectField from "../formik/SelectField";
import {
    useEffect,
    useRef,
    useState
} from "react";
import { MFTextField } from "../formik";
import { LoadingButton } from "@mui/lab";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useRouteMatch } from "react-router";
import { initiatePayment } from "../../redux-store/actions/cart";
import {
    GetOrderPreviewResponseBody,
    InitiatePaymentResponseBody
} from "../../redux-store/types/cart";
import { showError } from "../../redux-store/actions/auth";
import { SuccessIcon } from "../../assets/SvgIcons";
import { RootStateType } from "../../redux-store/reducers";
import { MandateSelectionDialog } from "../../components/investorOverview/transcation/Mandate";
import { getMandatesList } from "../../redux-store/actions/investorProfile";

interface Values {
    bankAccount: {
        bankAccountNumber: string,
        bankName: string,
        ifscCode: string
    } | null,
    mandateId: string
    mandate: string
}

interface RouterStateData {
    token: string
    cartId: string
    login_token?: string
    clientCode?: string
    portfolioId?: string
}

const initialValues: Values = {
    bankAccount: null,
    mandateId: "",
    mandate: ""
}

const validationSchema = Yup.object().shape({
    bankAccount: Yup
        .object()
        .nullable()
        .test(
            "bank-account-required",
            "Bank Account is required",
            function (value) { return !!value }
        ),
    mandateId: Yup.string().required("Mandate is required")
})

export default function OneTimeMandate({
    bankDetailsData,
    orderPreviewData
}: {
    bankDetailsData: MandateCreation[];
    orderPreviewData: { payable_amount: number, orderId: string, isIndividualPayment: boolean }
}): JSX.Element {
    const dispatch = useDispatch()
    const history = useHistory();
    const routerStateObj = history.location.state as RouterStateData
    const { url } = useRouteMatch();
    const formikRef = useRef<FormikProps<Values>>(null);

    const [intitLoading, setIntitLoading] = useState<boolean>(false)
    const [isLoading, setLoading] = useState<boolean>(false)
    const [isDialogOpen, setDialogOpen] = useState<boolean>(false)
    const [initiatePaymentResponse, setInitiatePaymentResponse] = useState<any>({})
    const LOOPBACKURL = `${window.location.origin}/bsetrade`;
    const isIndividualPayment = orderPreviewData?.isIndividualPayment ?? false;
    const { isInvestorRedirect = false, investorClientId, clientInterfaceCode } = useSelector((store: RootStateType) => store.auth);
    const [activeMandateList, setActiveMandateList] = useState<MandateListItem[]>([]);
    const [isMandateSelectDialogOpen, setMandateSelectDialogOpen] = useState<boolean>(false)

    const fetchMandateList = async () => {
        try {
            setIntitLoading(true);
            const response = await (dispatch(getMandatesList({ clientCode: routerStateObj?.clientCode, status: "Active", portfolioId: routerStateObj?.portfolioId, temporaryToken: routerStateObj?.login_token ?? "", })) as unknown as Promise<MandatesListResBody>);
            setActiveMandateList(response?.mandates?.filter(obj => obj?.amount >= orderPreviewData?.payable_amount) ?? []);

        } catch (e) {
            console.log('error', e);
        } finally {
            setIntitLoading(false);
        }
    }

    const handleSubmit = async (values: Values) => {
        try {

            const payment = {
                cartId: routerStateObj?.cartId ?? "",
                token: routerStateObj?.token ?? "",
                paymentMode: "DIRECT",
                accountNumber: values?.bankAccount?.bankAccountNumber ?? "",
                bankName: values?.bankAccount?.bankName ?? "",
                ifsc: values?.bankAccount?.ifscCode ?? "",
                loopbackURL: LOOPBACKURL,
                isIndividualPayment,
                mandateId: values?.mandateId,
                temporaryToken: routerStateObj?.login_token ?? "",
                ...(isIndividualPayment && { bseOrderId: orderPreviewData?.orderId })
            }


            setLoading(true);

            const response = await (dispatch(initiatePayment(payment)) as unknown as Promise<InitiatePaymentResponseBody>)

            if (!response?.isSuccess) {
                dispatch(showError(response?.response ?? ""))
            }
            else {
                setInitiatePaymentResponse(response)
                setDialogOpen(true)
            }
        } catch (e) {
            console.log('error', e);
        } finally {
            setLoading(false);
        }
    }

    const handleDialogClose = () => {
        setDialogOpen(false)
        history.replace({
            pathname: url,
            state: {
                ...routerStateObj,
                isPaymentDone: true
            }
        })
    }

    const path = history.location.pathname;

    const handleNavigateToOrders = () => {
        // const previousPath = path.substring(0, path.lastIndexOf('/'));
        // history.push(previousPath);

        history.goBack();
    }

    useEffect(() => {
        fetchMandateList();
    }, [])


    const handleOpenMandateSelectDialog = () => {
        setMandateSelectDialogOpen(true)
    }

    const handleCloseMandateSelectDialog = () => {
        setMandateSelectDialogOpen(false)
    }

    const handleMandateSelection = (mandateId: string, setFieldValue: any) => {
        const mandate = activeMandateList.find(obj => obj?.mandateId === mandateId);
        setFieldValue(`mandateId`, mandateId);
        setFieldValue('mandate', `${mandate?.bankName}-${mandate?.accountNo} (${mandate?.mandateId})`);
        setFieldValue('bankAccount', { bankAccountNumber: mandate?.accountNo, bankName: mandate?.bankName, ifscCode: mandate?.ifscCode });
        setMandateSelectDialogOpen(false)
    }

    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={validationSchema}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        {
                            intitLoading
                                ? <LinearProgress />
                                :
                                <Box>
                                    <Grid
                                        container
                                        columnSpacing={3}
                                        rowSpacing={2}
                                        sx={{ marginTop: "20px" }}
                                    >
                                        {
                                            activeMandateList.length == 0
                                                ? <Grid item xs={12} lg={6}>
                                                    <Typography variant="body_500" sx={(theme: Theme) => ({
                                                        color: theme.palette.text.primary,
                                                        lineHeight: "30px",
                                                        letterSpacing: "0.02px",
                                                        textAlign: "center",
                                                        paddingLeft: "10px",
                                                        paddingRight: "10px"
                                                    })} >
                                                        No Active Mandates, Please select some other payment mode.
                                                    </Typography>
                                                </Grid>
                                                : <Grid item xs={12} lg={6}>
                                                    <MFTextField
                                                        name="mandate"
                                                        label="Mandate*"
                                                        placeholder="Select Mandate"
                                                        value={values?.mandate}
                                                        disabled={true}
                                                    />

                                                    {activeMandateList.length !== 0 &&
                                                        <Button
                                                            sx={(theme: Theme) => ({
                                                                ...theme.typography.body_500,
                                                                color: theme.palette.primary[500],
                                                                textDecoration: 'underline',
                                                                padding: 0,
                                                                ':hover': {
                                                                    backgroundColor: "transparent"
                                                                }
                                                            })}
                                                            onClick={handleOpenMandateSelectDialog}
                                                            disabled={false}
                                                        >
                                                            Select Mandate
                                                        </Button>}
                                                </Grid>

                                        }
                                    </Grid>
                                    {activeMandateList.length !== 0 && <Grid item xs={4}>
                                        <LoadingButton
                                            type="submit"
                                            variant="contained"
                                            loading={isLoading}
                                            loadingPosition="center"
                                            disabled={!orderPreviewData?.payable_amount}
                                            sx={(theme: Theme) => ({
                                                ...theme.typography.body_500,
                                                fontWeight: 700,
                                                lineHeight: "22.5px",
                                                letterSpacing: "0.02px",
                                                color: theme.palette.textDark.primary,
                                                borderRadius: "10px",
                                                padding: "13px 56px",
                                                boxShadow: "none",
                                                backgroundColor: theme.palette.primary[500],
                                                width: "100%",
                                                mt: 4
                                            })}
                                        >
                                            SUBMIT
                                        </LoadingButton>
                                    </Grid>}
                                </Box>
                        }
                        <MandateSelectionDialog
                            open={isMandateSelectDialogOpen}
                            onClose={handleCloseMandateSelectDialog}
                            currentMandateId={values?.mandateId}
                            mandateList={activeMandateList}
                            handleMandateSelection={(mandateId) => handleMandateSelection(mandateId, setFieldValue)}
                        />
                    </Form>
                )}
            </Formik>
            <Dialog
                aria-labelledby="success-dialog"
                open={isDialogOpen}
                PaperProps={{
                    sx: (theme: Theme) => ({
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: theme.palette.common.white
                    }),
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <SuccessIcon />
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Success
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        {initiatePaymentResponse?.response ?? ""}
                    </Typography>
                    {!isInvestorRedirect && <Typography
                        variant="body_500"
                        sx={(theme: Theme) => ({
                            lineHeight: "30px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.primary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        })}
                    >
                        You can close this tab.
                    </Typography>}
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={isIndividualPayment ? handleNavigateToOrders : handleDialogClose}
                        sx={(theme: Theme) => ({
                            ...theme.typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: theme.palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: theme.palette.primary[500]
                        })}
                    >
                        {isIndividualPayment ? 'Go to Orders' : 'Okay'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
